module.exports = __webpack_public_path__ + "static/gf-1f63576184a1f3d583e7b148476ef8cd.png";